<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>合作产品期间路径</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item">
                <el-input v-model="queryParams.rid" placeholder="请输入RID" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" >
                <el-input v-model="queryParams.ppa_code" placeholder="请输入PPA编码" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.supplier_rid">
                <vSearchSelect
                    model_key="supplier_rid"
                    model_name="请输入供方搜索"
                    request_uri="searchAccounts"
                    default_option_key="supplier_option"
                    :default_option="queryParams['supplier_option']"
                    @onDropChange="onDropChange"
                    ref="supplier_rid_ref"
                ></vSearchSelect>
            </div>

            <div class="main_header_item" v-if="postList.demander_rid">
                <vSearchSelect
                    model_key="demander_rid"
                    model_name="请输入需方搜索"
                    request_uri="searchAccounts"
                    default_option_key="demander_option"
                    :default_option="queryParams['demander_option']"
                    @onDropChange="onDropChange"
                    ref="demander_rid_ref"
                ></vSearchSelect>
            </div>

            <div class="main_header_item" v-if="postList.partner_rid">
                <vDropdown
                    model_key="partner_rid"
                    model_name="请选择合作方"
                    :model_value_default="queryParams['partner_rid']"
                    request_uri="dropdownPartners"
                    @onDropChange="onDropChange"
                    ref="partner_rid_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.product_rid">
                <vDropdown
                    model_key="product_rid"
                    model_name="请选择产品"
                    :model_value_default="queryParams['product_rid']"
                    request_uri="dropdownProducts"
                    :request_params="{ type_code: [11, 91] }"
                    @onDropChange="onDropChange"
                    ref="product_rid_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.status">
                <vDropdown
                    model_key="status"
                    model_name="请选择状态"
                    select_value="value"
                    request_uri="dropdownCommonStatus"
                    :model_value_default="queryParams['status']"
                    @onDropChange="onDropChange"
                    ref="status_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.date">
                <el-date-picker
                    v-model="queryParams['date']"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="insert" icon="el-icon-plus" v-if="postList.addBtn" :loading="btnLoading"
                    >新增</el-button
                >

                <el-button size="small" plain @click="syncFromSf" v-if="postList.syncFromSfBtn" :loading="btnLoading">刷新SF中间表</el-button>

                <el-button size="small" plain @click="match" v-if="postList.matchBtn" :loading="btnLoading">匹配业务</el-button>
                <el-button size="small" plain @click="matchFlow" v-if="postList.matchBtn" :loading="btnLoading">匹配流向</el-button>
                <el-button size="small" plain @click="initLine" v-if="postList.matchBtn" :loading="btnLoading">初始化行</el-button>

                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(2)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload obj="transaction_config" :queryParams="queryParams"></crm-upload>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="transaction_config"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope">
                            <div v-if="in_array(item.prop, ['demander', 'supplier', 'partner', 'product', 'rid'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="update(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="禁用" placement="top-start">
                            <i class="el-icon-error" @click="disable(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="del(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array, onDelete } from '@/js/common.js';
import draggableList from '@/components/common/Drawer.vue';
import crmUpload from '@/components/common/Upload.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload,
        vSearchSelect
    },
    name: 'transactionConfigComponent',
    data() {
        return {
            draggable: {
                data_name: 'transaction_config'
            },
            down_loading: false,
            btnLoading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                // 填入相应的参数，调用getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        //跳转详情
        toDetail(row, prop) {
            if (prop == 'demander' && row.demander_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.demander_rid
                    }
                });
            } else if (prop == 'supplier' && row.supplier_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.supplier_rid
                    }
                });
            } else if (prop == 'product' && row.product_rid != '') {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: row.product_rid
                    }
                });
            } else if (prop == 'partner' && row.partner_rid != '') {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: row.partner_rid
                    }
                });
            } else if (prop == 'rid' && row.rid != '') {
                this.$router.push({
                    path: '/transactionConfigDetail',
                    query: {
                        id: row.rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0,
                rid: '',
                supplier_rid: '',
                demander_rid: '',
                partner_rid: '',
                product_rid: '',
                promotion_type: '',
                status: '',
                date: ''
            };

            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('transaction_config_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('transaction_config_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('transaction_config', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).transaction_config;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'transactionConfigLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        reset() {
            this.initQueryParams();
            this.getList();
        },
        //新增
        insert() {
            this.$router.push({
                path: 'transactionConfigEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //匹配业务
        match() {
            this.$confirm('您确定要匹配业务吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['transactionConfigMatch']({})
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        //匹配流向
        matchFlow() {
            this.$confirm('您确定要匹配流向吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['transactionConfigMatchFlow']({})
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                            }
                            this.btnLoading = false;
                            this.reload();
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        initLine() {
            this.$confirm('您确定要初始化行吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['transactionConfigInitLine']({})
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                            }
                            this.btnLoading = false;
                            this.reload();
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        //同步自SF（刷新SF中间表）
        syncFromSf() {
            this.$confirm('您确定要刷新SF中间表吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['transactionConfigSyncFromSf']({})
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        //复制
        copy(rid) {
            this.$router.push({
                path: 'transactionConfigEdit',
                query: {
                    type: 'copy',
                    id: rid
                }
            });
        },
        //编辑
        update(rid) {
            this.$router.push({
                path: 'transactionConfigEdit',
                query: {
                    type: 'update',
                    id: rid
                }
            });
        },
        disable(rid) {
            this.$confirm('您确定要禁用吗，禁用后不能重新开启？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.$api['transactionConfigDisable']({ rid: rid })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {});
        },
        //删除
        del(row) {
            onDelete(row.id, this, 'transactionConfigDelete', row.name);
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>